import React, { ReactElement } from "react";
import styles from "./styles.module.scss"
import { Box, Button, Typography } from "@mui/material";

import workWithUsIcon from "../assets/images/workWithUs.svg"

export default function WorkWithUs(): ReactElement {
  return (
    <Box className={styles.workWithUsContainer}>
      <Box className={styles.infoContainer}>
        <Typography className={styles.title}>Travaille avec nous</Typography>
        <Box className={styles.content}>
          <Typography className={styles.contentLabel}>Si vous êtes un professionnel du jeu et que vous êtes prêt à rejoindre notre équipe, <br></br>nous attendons votre message.</Typography>
          <Typography className={styles.contentLabel}>Ensemble, nous pouvons créer une entreprise prospère.</Typography>
          <Typography className={styles.emailLabel}>E-mail: info.betun365@gmail.com</Typography>
          <a href="mailto:info.betun365@gmail.com" className={styles.mailLink}>
            <Button variant="contained" className={styles.mailButton}>Contactez-nous</Button>
          </a>
        </Box>
      </Box>
      <Box className={styles.imageContainer}>
        <img src={workWithUsIcon} className={styles.image} />
      </Box>
    </Box >
  )
}